import './CoordinateSystem.scss';

import { Typography } from '@trackman/web-shared-components';
import React from 'react';

type CoordinateSystemProps = {
  xLabel?: string;
  yLabel?: string;
  xTicks: (string | number)[];
  yTicks: (string | number)[];
  children?: React.ReactNode;
};

const CoordinateSystem = ({ xLabel, yLabel, xTicks, yTicks, children }: CoordinateSystemProps) => {
  return (
    <div className='CoordinateSystem'>
      <div className='chart-y'>
        {yLabel && (
          <Typography component='div' variant='label' className='label'>
            {yLabel}
          </Typography>
        )}
        <div className='tick-labels'>
          {yTicks.map((yTick, i) => (
            <Typography key={yTick + 'y' + i} variant='label' component='div' className='y-tick-label'>
              {yTick}
            </Typography>
          ))}
        </div>
      </div>
      <div className='chart'>
        <div className='x-ticks'>
          {xTicks.map((xTick, i) => (
            <div key={xTick + 'x' + i} className='x-tick' />
          ))}
        </div>
        <div className='y-ticks'>
          {yTicks.map((yTick, i) => (
            <div key={yTick + 'y' + i} className='y-tick' />
          ))}
        </div>
        <div className='chart-plot'>{children}</div>
      </div>
      <div />
      <div className='chart-x'>
        <div className='tick-labels'>
          {xTicks.map((xTick, i) => (
            <div key={xTick + 'x' + i} className='x-tick-label-container'>
              <Typography variant='label' component='div' className='x-tick-label'>
                {xTick}
              </Typography>
            </div>
          ))}
        </div>
        {xLabel && (
          <Typography component='div' variant='label' className='label'>
            {xLabel}
          </Typography>
        )}
      </div>
    </div>
  );
};

export default CoordinateSystem;
